import React from 'react'

export default function SearchBar({ handleSearchTermChange }) {
    return (
        <div className="search-bar__container">
            <input className="search-bar__input" placeholder="Search in recipes..." onChange={e => handleSearchTermChange(e.target.value)} />
        </div>
    )
}
